let timeout;
export const WindowUtil = {
    stop: function () {
        timeout = setTimeout(() => {
            window.stop();
        }, 5000);
    },

    cancel: function () {
        if (timeout) {
            clearTimeout(timeout);
            timeout = null;
        }
    },
};
